angular
  .module('contrast.settings.report', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment',
    'ui.bootstrap'
  ])
  .controller(
    'ReportSettingsCtrl',
    function (
      $scope,
      $q,
      logger,
      ReportFactory,
      TagFactory,
      ReportService,
      ErrorService
    ) {
      $scope.model = {}
      $scope.model.selectedTypes = []
      $scope.model.selectedStatus = []
      $scope.model.selectedTags = []

      $scope.settings = {}
      $scope.settings.types = []
      $scope.settings.status = []
      $scope.settings.tags = []

      $scope.select = {}
      $scope.select.types = ReportService.getAvailableReports()
      $scope.select.status = ReportService.getTraceStatus()
      $scope.select.severities = ReportService.getAvailableTraceSeverities()
      $scope.select.vulnOptions = $scope.select.status.concat(
        $scope.select.severities
      )

      init()

      function buildForm() {
        ReportFactory.getReportSettings().then(
          function (response) {
            $scope.model = ReportService.buildReportSettingsForm(
              response.data.settings,
              $scope.select.types,
              $scope.select.status,
              $scope.select.severities,
              $scope.select.tags
            )
            $scope.form.type.$setPristine(true)
            $scope.form.status.$setPristine(true)
            if ($scope.select.tags.length > 0) {
              $scope.form.tag.$setPristine(true)
            }
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      }

      function init() {
        $scope.select.tags = []
        return TagFactory.getTraceTagsByOrganization().then(
          function (response) {
            angular.forEach(response.data.tags, function (tag) {
              var tagO = {}
              tagO['value'] = tag
              tagO['text'] = tag
              $scope.select.tags.push(tagO)
            })

            buildForm()
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      }

      $scope.saveReportSettings = function () {
        var deferred = $q.defer()

        angular.forEach($scope.model.selectedTypes, function (type) {
          $scope.settings.types.push(type.value)
        })
        angular.forEach($scope.model.selectedStatus, function (status) {
          $scope.settings.status.push(status.value)
        })
        angular.forEach($scope.model.selectedTags, function (tag) {
          $scope.settings.tags.push(tag.value)
        })
        $scope.settings.include_status = $scope.model.includeStatus
        $scope.settings.include_notes = $scope.model.includeNotes
        $scope.settings.custom_footer = $scope.model.footer

        var vulnFilter = filterByType($scope.settings.status)
        $scope.settings.status = vulnFilter.status
        $scope.settings.severities = vulnFilter.severities

        ReportFactory.saveReportSettings($scope.settings).then(
          function (response) {
            var data = response.data
            logger.logSuccess(data.messages[0])
            $scope.settings.types = []
            $scope.settings.status = []
            $scope.settings.tags = []
            $scope.form.$dirty = false
            deferred.resolve()
          },
          function (response) {
            ErrorService.processError(response)
            deferred.reject()
          }
        )

        return deferred.promise
      }

      function filterByType(status) {
        var vulnerabilityFilter = {
          status: [],
          severities: []
        }

        angular.forEach(status, function (item) {
          if (
            _.findIndex($scope.select.severities, function (severity) {
              return severity.value === item
            }) != -1
          ) {
            vulnerabilityFilter.severities.push(item)
          } else {
            vulnerabilityFilter.status.push(item)
          }
        })

        return vulnerabilityFilter
      }
    }
  )
